<template>
    <div>
        <img class="leq-logo" src="logo-leq-horiz.bmp" 
            alt="Logo Leblon Equities">
        <h1 style="text-align: center">Bem vindo ao Sistema Leblon Equities</h1>
        <!-- Incluir link para documentação do Sistema? O que deveria aparecer na Home? -->
    </div>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'    
    
export default {
    name: 'home',
    async created() {
        if(firebase.auth().currentUser === null) return
        var idTokenResult = await firebase.auth().currentUser.getIdTokenResult()
        let userRole = idTokenResult.claims.role
        if(userRole === undefined || userRole === null) {
            this.$root.$emit('showError', 'Entre em contato com um administrador para validar a sua conta.', 'warning')
            return
        }
    }
}
    
</script>

<style scoped>
.leq-logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 70px 0;
}
</style>
